import * as Yup from 'yup';

import { AuthMode, isRecoverMode,isSignupMode } from '../../../constants/auth';

type ValidationSchema = Yup.ObjectSchema<{
  email: string;
  password: string | undefined;
  passwordConfirmation: string | undefined;
}>;

export const createAuthValidationSchema = (mode: AuthMode): ValidationSchema => {
  return Yup.object().shape({
    email: Yup.string()
      .email('Please enter a valid email address')
      .matches(
        /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
        'Please enter a valid email address'
      )
      .required('Email is required'),
    password: Yup.string()
      .when([], {
        is: () => !isRecoverMode(mode),
        then: (schema) => schema.required('Password is required'),
        otherwise: (schema) => schema.notRequired(),
      })
      .when([], {
        is: () => isSignupMode(mode),
        then: (schema) =>
          schema
            .min(8, 'Password must be at least 8 characters long')
            .test('not-email', 'Password must not match your email address', function (value) {
              const email = this.parent.email;
              return !value || !email || value !== email;
            })
            .test('min-unique-chars', 'Include at least 3 distinct characters', function (value) {
              if (!value) return true;

              // Check for unique characters
              const uniqueChars = new Set(value.split('')).size;
              if (uniqueChars < 3) return false;

              // Check for repeating patterns
              const halfLength = Math.floor(value.length / 2);
              for (let i = 1; i <= halfLength; i++) {
                const pattern: string = value.slice(0, i);
                const regExp: RegExp = new RegExp(`^(${pattern})+$`);
                if (regExp.test(value)) return false;
              }

              return true;
            }),
        otherwise: (schema) => schema,
      }),
    passwordConfirmation: Yup.string().when([], {
      is: () => isSignupMode(mode),
      then: (schema) =>
        schema
          .oneOf([Yup.ref('password')], 'Passwords must match')
          .required('Password confirmation is required'),
      otherwise: (schema) => schema.notRequired(),
    }),
  });
}; 